import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem
} from '@angular/cdk/drag-drop';
import { interval, never, BehaviorSubject } from 'rxjs';

import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import 'rxjs/add/operator/map';
import { UserService } from '../../../shared/services/user.service';
import { RoomService } from '../../../shared/services/room.service';
import { ActivatedRoute } from '@angular/router';
import { startWith, switchMap } from 'rxjs/operators';
/* import { BOARD_GAME_SETTINGS, BoardGameSettings, Category } from './board-game.settings'; */
import { Log } from '../../../shared/components/log/models/log.model';
import { ModalType } from '../../../shared/components/modal/models/modal.model';
import { Modal } from '../../../shared/components/modal/models/modal.model';
import { CardUtils } from '../../../shared/components/cards-engine/components/card/utils/card.utils';
import { ObjectUtils } from '../../../shared/utils/object.utils';
import { Card, Cards } from './components/card/models/card.model';
import { HubService } from '../../services/hub.service';
import { BoardGameSettings } from './models/cards-engine.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cards-engine',
  templateUrl: './cards-engine.component.html',
  styleUrls: ['./cards-engine.component.scss']
})
export class CardsEngineComponent implements OnInit, OnDestroy {
  selectedBoardTabs: { id: string; selectedIndex: number }[] = [];

  shakeTabInfos: boolean;

  @Input()
  boardGameSettings: BoardGameSettings; //  = BOARD_GAME_SETTINGS;

  get lockBoard(): boolean {
    return this.roomService.lockBoard;
  }

  set lockBoard(lockBoard: boolean) {
    this.roomService.lockBoard = lockBoard;
  }

  selectedIndex: number = 0;
  showCardFocus: Card; // Zoom on card

  isDraggable: boolean = true;

  firstPlayer: number = 0;

  cards: Cards;

  get room() {
    return this.roomService.room;
  }
  set room(room) {
    this.roomService.room = room;
  }

  get user() {
    return this.userService.user;
  }
  set user(user) {
    this.userService.user = user;
  }

  game: { firstPlayerIndex?: number };

  private _modal: Modal = {
    modalType: null,
    player: null,
    title: null,
    category: null,
    content: null
  };

  get modal(): Modal {
    return this._modal;
  }

  set modal(modal: Modal) {
    this._modal = modal;
  }

  modalZoom: number = 1;

  get name() {
    return this.user && this.user.displayName;
  }

  get logs(): Log[] {
    return this.roomService.logs;
  }
  set logs(logs: Log[]) {
    this.roomService.logs = logs;
  }

  // TODO type
  counters: {
    villain: { first: number; second: number };
    player1: { first: number; second: number };
    player2: { first: number; second: number };
  };

  get roomId(): string {
    //  = '-M3xECwYK6ml8ewQT4o5'
    return this.roomService.roomId;
  }
  set roomId(roomId: string) {
    this.roomService.roomId = roomId;
  }

  get roomRef(): AngularFireList<any> {
    return this.roomService.roomRef;
  }
  set roomRef(roomRef: AngularFireList<any>) {
    this.roomService.roomRef = roomRef;
  }

  currentDragPosition: { x: number; y: number };
  matTabLastCurrentFix = {
    indexHovered: null,
    trigered: null,
    delay: 50
  };
  playing = new BehaviorSubject(false);
  observable = this.playing.pipe(
    switchMap(e =>
      !!e
        ? interval(this.matTabLastCurrentFix.delay).pipe(startWith('start'))
        : never()
    )
  );

  get lang() {
    return this.translate.currentLang;
  }

  constructor(
    private roomService: RoomService,
    private afd: AngularFireDatabase,
    private route: ActivatedRoute,
    private userService: UserService,
    private hubService: HubService,
    public translate: TranslateService
  ) {}

  hubRoomRef;
  hubId;
  hub;

  roomRefSubscription;
  hubRoomRefSubscription;

  ngOnInit() {
    this.initSelectedBoardTabs(this.boardGameSettings);

    // delay the selectIndex hovering result
    this.observable.subscribe(e => {
      if (e >= 4) {
        this.selectedIndex = this.matTabLastCurrentFix.indexHovered;
        this.matTabLastCurrentFix.indexHovered = null;
        this.playing.next(false);
      }
    });

    this.route.params.subscribe(res => {
      this.roomId = res.roomId;

      this.roomRef = this.afd.list(`rooms/${this.roomId}`);
      this.roomRefSubscription = this.roomRef
        .snapshotChanges()
        .map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        })
        .subscribe(res => {
          this.cards = res.find(res => res.key === 'cards');
          this.cards.villain = ObjectUtils.initializeObjectAttributes(
            this.cards.villain,
            [
              'discard',
              'deck',
              'schemes',
              'villains',
              'upgrades',
              'minions',
              'purge',
              'reveals',
              'archives'
            ]
          );
          this.cards.player1 = ObjectUtils.initializeObjectAttributes(
            this.cards.player1,
            [
              'discard',
              'deck',
              'champion',
              'playGround',
              'hand',
              'purge',
              'reveals',
              'archives'
            ]
          );
          /* this.cards.player2 = ObjectUtils.initializeObjectAttributes(this.cards.player2, ['discard', 'deck', 'champion', 'playGround', 'hand', 'purge']); */
          if (this.cards.player2) {
            this.cards.player2 = ObjectUtils.initializeObjectAttributes(
              this.cards.player2,
              [
                'discard',
                'deck',
                'champion',
                'playGround',
                'hand',
                'purge',
                'reveals',
                'archives'
              ]
            );
          }
          const logsArray = res.find(res => res.key === 'logs');
          this.roomService.logs = logsArray ? Object.values(logsArray) : [];
          this.counters = res.find(res => res.key === 'counters');
          this.game = res.find(res => res.key === 'game');
          this.room = res.find(res => res.key === 'room');
          this.hubId = res.find(res => res.key === 'hub');

          this.hubRoomRef = this.afd.list(`hub/${this.hubId.hubId}`);
          this.hubRoomRefSubscription = this.hubRoomRef
            .snapshotChanges()
            .subscribe(hub => {
              this.hub = hub;
              const hubTabKey = hub
                .find(res => res.key === 'tabKey')
                .payload.val();

              if (hubTabKey === 'gamewin' || hubTabKey === 'gameloose') {
                this.roomRefSubscription.unsubscribe();
                this.hubRoomRefSubscription.unsubscribe();
              } else {
                const hubPlayers = hub
                  .find(res => res.key === 'players')
                  .payload.val();

                // create tabs
                let players = [];
                for (let i = 1; i <= hubPlayers.length; i++) {
                  players.push('player' + i);
                }
                this.boardGameSettings.boards[1].players = players;
              }
            });
        });
    });
  }

  ngOnDestroy() {
    this.roomRefSubscription.unsubscribe();
    this.hubRoomRefSubscription.unsubscribe();
  }

  logsInputChanges(log: Log) {
    log.prefix = this.name;
    this.roomService.updateRoom(`${this.roomId}/logs`, this.logs, log);
  }

  actionDropList(event: CdkDragDrop<string[]>, category) {
    this.matTabLastCurrentFix.indexHovered = null;

    if (this.isActivePlayer()) {
      if (event.previousContainer === event.container) {
        moveItemInArray(
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      } else {
        try {
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex
          );
          if (category.removeAllTokenWhenDragIn) {
            this.removeAllTokensFromPlayerContainer(event);
          }
        } catch (error) {
          console.error(error);
        }

        // reset toggleSide
        /* console.log(
          "actionDropList",
          event.container.data,
          event.container.data[event.currentIndex],
          event.currentIndex
        ); */
        if (
          event.container.data &&
          event.container.data[0] &&
          event.container.data[0]['actions']
        ) {
          // event.container.data[0]["actions"] = null;
          event.container.data[event.currentIndex]['actions'] = null;
        }

        this.lockBoard = true;
        const log: Log = {
          template: 'Default',
          prefix: this.name,
          label: `plays ${event.container.data[event.currentIndex]['name']}`
        };
        this.roomService.updateRoom(`${this.roomId}/cards`, this.cards, log);
      }
    } else {
      this.addNotActivePlayerLocalLog();
    }
    this.modal = null; // used to fix refresh cards
  }

  removeAllTokensFromPlayerContainer(event) {
    let currentCard: Card = event.container.data[event.currentIndex];
    currentCard['tokens'] = {};
    console.log('removeAllTokensFromPlayerContainer', currentCard);
    /* function getContainerByCardId(cards: Cards, cardId: string): {player: string, container: string} {
      let result = null;
      for (let playerName of Object.keys(cards)) {
        const cardContainers = cards[playerName];
        for (let cardContainerName of Object.keys(cardContainers)) {
          const cards = cardContainers[cardContainerName];
          for (let card of cards) {
            if (card.id === cardId) {
              result = {player: playerName, container: cardContainerName};
            }
          }
        }
      }
      return result;
    }

    const currentCard: Card = event.container.data[event.currentIndex];
    const targetContainer: {player: string, container: string} = getContainerByCardId(this.cards, currentCard.id);
    const targetContainerWithoutNumber = targetContainer.player.replace(/\d+$/, '');
    const rowCardContainer = RowCardContainers.find(rcc => rcc.player === targetContainerWithoutNumber && rcc.id === targetContainer.container);
    // remove all tokens
    try {
      if (rowCardContainer && rowCardContainer.removeAllTokenWhenDragIn) {
        for (let card of this.cards[targetContainer.player][targetContainer.container]) {
          card.tokens = {};
        }
      }
    } catch(error) {
      console.log('removeAllTokensFromPlayerContainer error', error, rowCardContainer);
    } */
  }

  addNotActivePlayerLocalLog() {
    this.shakeTabInfos = true;
    this.logs.push({
      template: 'Error',
      label: `You must be the active player to do this action.`,
      prefix: this.name
    });
    // scroll to bottom
    let objDiv = document.getElementById('logs');
    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight;
    }
    setTimeout(() => (this.shakeTabInfos = false), 750);
  }

  actionShuffle(a) {
    if (this.isActivePlayer()) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }

      const log: Log = {
        template: 'Default',
        label: `${this.name} is shuffling his deck`,
        prefix: this.name
      };
      this.roomService.updateRoom(`${this.roomId}/cards`, this.cards, log);
      return a;
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  actionToggleSide(card: Card, player) {
    if (this.isActivePlayer()) {
      if (card['actions'] === undefined) {
        card['actions'] = {};
      }

      if (!card['actions']['toggleSide']) {
        card['actions']['toggleSide'] = 'front';
      } else {
        card['actions']['toggleSide'] =
          card['actions']['toggleSide'] === 'front' ? 'back' : 'front';
      }
      const log: Log = {
        template: 'Default',
        label: `change side of card`,
        prefix: this.name
      };
      this.roomService.updateRoom(`${this.roomId}/cards`, this.cards, log);
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  actionToggleRotate(card: Card, player) {
    if (this.isActivePlayer()) {
      CardUtils.rotate(card);
      const log: Log = {
        template: 'Default',
        label: 'rotate card',
        prefix: this.name
      };
      this.roomService.updateRoom(`${this.roomId}/cards`, this.cards, log);
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  actionToken($event: {
    card: Card;
    counterChangeEvent: { template: string; value: number };
  }) {
    if (this.isActivePlayer()) {
      CardUtils.token($event);
      const log: Log = {
        template: 'Default',
        label: 'change token',
        prefix: this.name
      };
      this.roomService.updateRoom(`${this.roomId}/cards`, this.cards, log);
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  counterChange(event, player) {
    if (this.isActivePlayer()) {
      const log: Log = {
        template: 'Default',
        prefix: this.name,
        label: `is setting ${player} counter to ${event.first} - ${
          event.second
        }`
      };
      this.roomService.updateRoom(
        `${this.roomId}/counters`,
        this.counters,
        log
      );
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  selectMatTabHovered(event) {
    this.currentDragPosition = event.pointerPosition;

    let matTabs: HTMLCollectionOf<Element> = document.getElementsByClassName(
      'tab-label-custom'
    );

    let match = false;

    for (let i = 0; i < matTabs.length; i++) {
      let matTab = matTabs[i];

      let isXMatch =
        this.currentDragPosition.x >= matTab.getBoundingClientRect()['x'] &&
        this.currentDragPosition.x <=
          matTab.getBoundingClientRect()['x'] +
            matTab.getBoundingClientRect().width;

      let isYMatch =
        this.currentDragPosition.y >= matTab.getBoundingClientRect()['y'] &&
        this.currentDragPosition.y <=
          matTab.getBoundingClientRect()['y'] +
            matTab.getBoundingClientRect().height;

      // delay
      if (isXMatch && isYMatch) {
        // this single one for non delay: this.selectedIndex = i;
        // else
        match = true;
        if (this.matTabLastCurrentFix.trigered) {
          if (i === this.matTabLastCurrentFix.indexHovered) {
            // do nothing, its the same index
          } else {
            // restart delay
            this.matTabLastCurrentFix.indexHovered = i;
            this.playing.next(false);
            this.playing.next(true);
          }
        } else {
          // start delay
          this.matTabLastCurrentFix.trigered = true;
          this.matTabLastCurrentFix.indexHovered = i;
          this.playing.next(true);
        }
      }
    }
    if (!match) {
      this.matTabLastCurrentFix.indexHovered = null;
      // stop delay
      this.playing.next(false);
    }
  }

  changeFirstPlayer(playerIndex: number) {
    if (this.isActivePlayer()) {
      this.firstPlayer = playerIndex;
      const log: Log = {
        template: 'Default',
        prefix: this.name,
        label: `is changing first player token`
      };
      this.game['firstPlayerIndex'] = playerIndex;
      this.roomService.updateRoom(`${this.roomId}/game`, this.game, log);
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  trackByMethod(index: number, item: any): number {
    return item.id;
  }

  /* addRoomVisitor() {
    let localstorageUser = localStorage.getItem('localstorageUser');
    localstorageUser = localstorageUser ? JSON.parse(localStorage.getItem('localstorageUser')) : null;
    if (
      localstorageUser && this.room.users && this.room.users.find(user => user.uid === localstorageUser['uid'])
    ) {
      this.user = localstorageUser;
    } else { // create localstorage user
      const roomUsers = this.roomService.room.users;
      const roles = roomUsers && roomUsers.length >= this.roomService.room.settings.nbPlayers ? ['spectator'] : ['player'];
      const visitorUser = {
        uid: uuid(),
        displayName: 'visitor' + Math.floor(Math.random() * Math.floor(5000)),
        roles: roles, 
        activePlayer: false,
      };
      localStorage.setItem('localstorageUser', JSON.stringify(visitorUser));
      this.user = visitorUser;
      this.room.users.push(visitorUser);
      this.roomService.updateRoom(`${this.roomId}/room`, this.room);
    }
  } */

  displayBeActivePlayer(): boolean {
    return (
      !this.isActivePlayer() &&
      (this._userRestrictions && this._userRestrictions.playGame)
    );
  }

  isActivePlayer(): boolean {
    this._userRestrictions;
    let result =
      this.game &&
      this.game['activePlayer'] === this.user.uid &&
      this._userRestrictions &&
      this._userRestrictions.playGame;
    return result;
  }

  get _userRestrictions() {
    let hubPlayers =
      this.hub && this.hub.find(hub => hub.key === 'players').payload.val();

    let matchingRoomUser =
      hubPlayers && hubPlayers.find(roomUser => roomUser.uid === this.user.uid);
    return this.userService.userRestrictions(matchingRoomUser);
  }

  beActivePlayer(): void {
    if (!this.game) {
      this.game = {};
    }
    this.game['activePlayer'] = this.user.uid;
    this.roomService.updateRoom(`${this.roomId}/game`, this.game);

    this.logs.push({
      template: 'Default',
      prefix: this.name,
      label: `is now the active player`
    });
    this.roomService.updateRoom(`${this.roomId}/logs`, this.logs);
  }

  /* getCardContainers(player: string) {
    return null; // RowCardContainers.filter(res => res.player === player).map(rowCardContainer => rowCardContainer.id);
  } */

  getPlayerBoardContainersId(playerBoard: string, player: string): string[] {
    const board = this.boardGameSettings.boards.find(
      board => board.id === playerBoard
    );
    const containersId = board.rows
      .map(row =>
        row.categories.map(category =>
          category.categoryType === 'card' ? category.id : null
        )
      )
      .flat();
    return containersId.filter(containerId => containerId);
  }

  // from, to
  moveCardsToSelectedRowCardContainer(
    modal,
    selectedRowCardContainer,
    fromPlayer
  ) {
    if (this.isActivePlayer()) {
      if (modal.modalType === 'containerCards') {
        const categoryId: string = modal.category.id;
        const from = this.cards[modal.player][categoryId];
        const to = this.cards[fromPlayer][selectedRowCardContainer] as any;
        this.cards[modal.player][selectedRowCardContainer] = to.concat(from);
        this.cards[modal.player][categoryId] = [];
        this.modal = null;
        const log: Log = {
          template: 'Default',
          prefix: this.name,
          label: `is moving all card from ${
            modal.category.id
          } to ${selectedRowCardContainer}`
        };
        this.roomService.updateRoom(`${this.roomId}/cards`, this.cards, log);
      } else if (modal.modalType === 'attachmentsCards') {
        // TODO
      }
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  // Sometimes u want to display only one card, for example in deck.
  // To avoid ngfor with lot of images to load we use this function
  cardsToDisplayByCategory(cards, category) {
    return cards && cards.length > 0 && category.displaySingleCard
      ? [cards[0]]
      : cards;
  }

  actionSelectTokens() {
    if (this.isActivePlayer()) {
      this.roomService.updateRoom(`${this.roomId}/cards`, this.cards);
    } else {
      this.addNotActivePlayerLocalLog();
    }
  }

  actionAttachments(player, category, card) {
    if (!card.attachments) {
      card.attachments = [];
    }

    this.modal = {
      modalType: ModalType.ATTACHMENTS_CARDS,
      player: player,
      title: `Attachments of ${card.name}`,
      category: category,
      content: card.attachments
    };
  }

  selectBoardTab(boardId: string, boardTabIndex: number) {
    const selectedBoardTabIndex = this.selectedBoardTabs.findIndex(
      selectedBoardTab => selectedBoardTab.id === boardId
    );
    this.selectedBoardTabs[selectedBoardTabIndex].selectedIndex = boardTabIndex;
  }

  isSelectedBoardTab(boardId: string, boardTabIndex: number): boolean {
    const selectedBoardTab = this.selectedBoardTabs.find(
      selectedBoardTab => selectedBoardTab.id === boardId
    );
    return selectedBoardTab && selectedBoardTab.selectedIndex === boardTabIndex;
  }

  initSelectedBoardTabs(boardGameSettings) {
    for (let board of boardGameSettings.boards) {
      this.selectedBoardTabs.push({ id: board.id, selectedIndex: 0 });
    }
  }

  isForcePortrait(card, category): boolean {
    /* return;
    card.metadatas.tags.includes("MAINschemesME") ||
      card.metadatas.tags.includes("SIDESCHEME") ||
      category.forcePortrait; */
    let result;
    if (category.forcePortrait) {
      result = false;
    } else if (
      card.metadatas.tags.includes('MAINSCHEME') ||
      card.metadatas.tags.includes('SIDESCHEME')
    ) {
      result = true;
    }
    return result;
  }

  clickCardBody(card, category) {
    if (category.displayFrontAsDefaultSide) {
      this.showCardFocus = card;
    }
  }

  hoverCardBody(card: Card, entering: boolean, category) {
    if (entering && (category.hover || category.hover === undefined)) {
      this.showCardFocus = card;
    } else {
      this.showCardFocus = null;
    }
  }
}
